import {makeAutoObservable} from "mobx";
import GoodsType from "enum/GoodsType";
import * as Api from "api/api";

class SearchStore {
    keyword = '';
    goodsType = GoodsType.ALL;
    goodsList = [];
    totalNum = 0;
    condition = null;
    fromPrice = 0;
    toPrice = 0;
    categoryId = 0;
    isNew = null;
    isHot = null;
    defaultPage = {
        size: 60,
        num: 1
    }
    page = {...this.defaultPage}
    categoryList = []
    selectedCategoryList = []
    recommendKeywordList = []
    recommendList = []
    guessList = []

    init() {
        this.keyword = ''
        this.goodsList = [];
        this.goodsType = GoodsType.ALL;
        this.totalNum = 0;
        this.condition = null;
        this.fromPrice = 0;
        this.toPrice = 0;
        this.categoryId = 0;
        this.isNew = null;
        this.isHot = null;
        this.page = {...this.defaultPage}
        this.categoryList = []
        this.selectedCategoryList = []
        this.recommendKeywordList = []
        this.recommendList = []
        this.guessList = []
    }

    setKeyword(keyword) {
        this.keyword = keyword
    }

    setGoodsType(goodsType) {
        this.goodsType = goodsType
    }

    setGoodsList(goodsList) {
        this.goodsList = goodsList
    }

    setTotalNum(totalNum) {
        this.totalNum = totalNum
    }

    setCondition(condition) {
        this.condition = condition
    }

    setFromPrice(fromPrice) {
        this.fromPrice = fromPrice
    }

    setToPrice(toPrice) {
        this.toPrice = toPrice
    }

    setCategoryId(categoryId) {
        this.categoryId = categoryId
    }

    setIsNew(isNew) {
        this.isNew = isNew
    }

    setIsHot(isHot) {
        this.isHot = isHot
    }

    setPageSize(pageSize) {
        this.page.size = pageSize
    }

    setPageNum(pageNum) {
        this.page.num = pageNum
    }

    setCategoryList(categoryList) {
        this.categoryList = categoryList
    }

    setSelectedCategoryList(selectedCategoryList) {
        this.selectedCategoryList = selectedCategoryList
    }

    pushSelectedCategoryList(category) {
        this.selectedCategoryList = [
            ...this.selectedCategoryList,
            category
        ]
    }

    truncateSelectedCategoryList(index) {
        const length = this.selectedCategoryList.length;
        this.selectedCategoryList.splice(index, length - index)
    }

    setRecommendKeywordList(recommendKeywordList) {
        this.recommendKeywordList = recommendKeywordList
    }

    setRecommendList(recommendList) {
        this.recommendList = recommendList
    }

    setGuessList(guessList) {
        this.guessList = guessList
    }

    async fetchGoodsList(
        {
            selfFlag,
            categoryId,
            isNew,
            isHot,
            keyword,
            order,
            sortFiled,
            fromPrice,
            toPrice,
            pageSize,
            pageNum,
            goodsType,
            isSpecialPrice,
        },
        callback
    ) {
        this.setGoodsList([])
        const {list, totalNum} = await Api.searchGoods({
            selfFlag,
            page: pageNum,
            size: pageSize,
            goodsType,
            keyword,
            isNew,
            isHot,
            order,
            orderBy: sortFiled,
            categoryId,
            fromPrice,
            toPrice,
        });
        this.setGoodsList(list)
        this.setTotalNum(totalNum)
        callback()
    }

    async fetchCategoryList() {

        const nav = await Api.nav();

        let list = [];
        const {
            list: pddGoodsCategoryList,
            hasSelfCategory,
        } = await Api.pddGoodsCategoryList({
            parentId: 0,
        });
        list.push(...pddGoodsCategoryList);
        if (hasSelfCategory) {
            list = [
                {
                    id: 0,
                    name: nav?.selfRun,
                    isSelf: true,
                },
                ...list,
            ];
        }

        this.setCategoryList(list)
    }

    async fetchChildCategoryList(
        {
            parentId,
            parentOptId,
            isSelect,
            isSelf,
        }
    ) {
        if (parentId === -1) {
            await this.fetchCategoryList()
        } else {
            try {
                let list = [];

                if (isSelf) {
                    const {list: goodsCategoryList} = await Api.childGoodsCategoryList({
                        parentId,
                    });
                    list.push(...goodsCategoryList);
                } else {
                    let {
                        list: pddGoodsCategoryList,
                    } = await Api.pddChildGoodsCategoryList({
                        parentId,
                        parentOptId,
                        isSelect,
                    });
                    list.push(...pddGoodsCategoryList);
                }

                this.setCategoryList(list)
            } catch (error) {
            }
        }
    }

    async fetchRecommendKeywordList({keyword}) {
        try {
            keyword = "笔记本";
            const res = await Api.recommendKeywordList({keyword});
            // fixme 没有设置
            // setRecommendList(res)
        } catch (error) {
            console.log(error);
        }
    }

    async fetchRecommendList() {
        let {list} = await Api.recommendList({
            pageSize: 13,
            pageNum: 1,
        });

        list = list?.splice(0, 13);

        this.setRecommendList(list)
    }

    async fetchGuessList() {
        let {list} = await Api.recommendList({
            pageSize: 6,
            pageNum: 1,
        });

        list = list.splice(0, 6);

        this.setGuessList([])
        this.setGuessList(list)
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const searchStore = new SearchStore();

export default searchStore;